import {usePlantStartOfToday} from '@hconnect/upm'
import {useMemo} from 'react'

import type {MomentRange} from '../types'

interface UsePlanRangeParams {
  days?: number
}

export const usePlanRange = ({days = 8}: UsePlanRangeParams = {}): MomentRange => {
  const startOfPlan = usePlantStartOfToday()

  return useMemo(() => {
    const endOfPlan = startOfPlan.clone().add(days, 'day')
    return [startOfPlan, endOfPlan]
  }, [startOfPlan, days])
}
